(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["altitude-product-grid"] && !Shopify.designMode) return;
  try {
    
    let productGridContainer = document.getElementById('product-grid-container-js');
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altitude-promo-block"] && !Shopify.designMode) return;
  try {
    
let productGridContainer = document.getElementById('product-grid-container-js');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altitude-promo-mosiac"] && !Shopify.designMode) return;
  try {
    
let productGridContainer = document.getElementById('product-grid-container-js');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altitude-rotating-banner"] && !Shopify.designMode) return;
  try {
    
const bannerSlider = document.getElementById('rotating-banner-js');
    let iteration = 0;
    let numberOfSlides = document.getElementsByClassName('rotating-banner--item').length;
    setInterval(() => {
        if(iteration < numberOfSlides - 1) {
            bannerSlider.scrollLeft += window.innerWidth;
            iteration++;
        } else {
            bannerSlider.scrollLeft = 0;
            iteration = 0;
        }
    }, 3000);

  } catch(e) { console.error(e); }
})();
})();
